import styled from 'styled-components'
import Description from '../../components/Description/Description'
import Title from '../../components/Title/Title'
import chrome from '../../images/icons/chrome-icon.svg'
import firefox from '../../images/icons/firefox-icon.svg'
import edge from '../../images/icons/edge-icon.svg'

const Container = styled.div`
  display: flex;
  justify-content: center;
  padding: 50px 0;
`
const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
`
const Grid1 = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 50px;
  justify-items: center;
`
const Button = styled.a`
  padding: 10px 15px;
  border-radius: 5px;
  text-decoration: none;
  color: inherit;
  display: flex;
  align-items: center;
  width: fit-content;
  transition: 0.2s ease-in;

  &:hover {
    transition: 0.2s ease-in;
    opacity: 0.6;
  }

  &.btn-chrome {
    background: #09512e;
  }

  &.btn-firefox {
    background: #a85c14;
    margin: 0 10px;
  }

  &.btn-edge {
    background: #186da1;
  }
`
const Icon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 10px;
`
const Buttons = styled.div`
  display: flex;
`

export default function Download() {
  return (
    <Container>
      <div className="container">
        <Wrapper>
          <Grid1>
            <Title title="Download now" />
            <Description description="It only takes 2 seconds to make your writing life better with GDark!" />
            <Buttons className="download__buttons">
              <Button
                href="https://chrome.google.com/webstore/detail/grammarly-dark/noojmhngiheennhgaffkfboanjpbkpep?hl=en"
                className="btn-chrome"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={chrome} alt="Chrome icon" />
                Download
              </Button>
              <Button
                href="https://addons.mozilla.org/en-US/firefox/addon/grammarly-dark/"
                className="btn-firefox"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={firefox} alt="Firefox icon" />
                Download
              </Button>
              <Button
                href="https://microsoftedge.microsoft.com/addons/detail/grammarly-dark/kljjdbdffnbengiilkaiblpinbhfcfnc?hl=en-US%3Fhl%3Den-US"
                className="btn-edge"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon src={edge} alt="Edge icon" />
                Download
              </Button>
            </Buttons>
          </Grid1>
        </Wrapper>
      </div>
    </Container>
  )
}
